module.exports = __webpack_public_path__ + "static/recupero-crediti-945f349bfd23dbb6a496ad9b1fe22e84.png";